/** @format */

export interface MissingImageEventInfo {
  color?: string;
  ecode?: string;
  pageUrl: string;
  productName?: string;
  requestedImg: string;
}
